(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bgs-ring-360"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bgs-ring-photo-360')) {
    customElements.define('bgs-ring-photo-360', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.details = this.querySelector('details');
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas.getContext('2d');
        this.status = this.querySelector('[role="status"]');
        this.rotation = this.querySelector('.bgs-ring360-rotation');
        this.zoom = this.querySelector('.bgs-ring360-zoom');
        this.play = this.querySelector('.bgs-ring360-play');
        this.retry = this.querySelector('.bgs-ring360-retry');
        this.frame = Number(this.rotation.value);
        this.details.addEventListener('toggle', () => {
          if (this.details.open) this.load();
          else this.stop();
        }, options);
        this.retry.addEventListener('click', () => this.load(), options);
        this.rotation.addEventListener('input', () => {
          this.stop();
          this.frame = Number(this.rotation.value);
          this.draw();
        }, options);
        this.zoom.addEventListener('input', () => this.draw(), options);
        this.play.addEventListener('click', () => {
          if (this.timer) this.stop();
          else {
            this.play.textContent = this.dataset.pause;
            this.play.setAttribute('aria-pressed', 'true');
            this.timer = setInterval(() => {
              this.frame = (this.frame + 1) % 70;
              this.draw();
            }, 100);
          }
        }, options);
        this.canvas.addEventListener('pointerdown', event => {
          if (!this.ready || !event.isPrimary || event.button !== 0) return;
          this.stop();
          this.drag = { id: event.pointerId, x: event.clientX, frame: this.frame };
          this.canvas.setPointerCapture(event.pointerId);
        }, options);
        this.canvas.addEventListener('pointermove', event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const delta = Math.round((event.clientX - this.drag.x) / this.canvas.clientWidth * 70);
          this.frame = ((this.drag.frame + delta) % 70 + 70) % 70;
          this.draw();
        }, options);
        const endDrag = () => { this.drag = null; };
        this.canvas.addEventListener('pointerup', endDrag, options);
        this.canvas.addEventListener('pointercancel', endDrag, options);
        this.canvas.addEventListener('lostpointercapture', endDrag, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
        }, options);
        if (this.details.open) this.load();
      }
      async load() {
        if (this.ready || this.loading) return;
        this.loading = true;
        this.retry.hidden = true;
        this.status.textContent = this.dataset.loading;
        this.canvas.setAttribute('aria-busy', 'true');
        try {
          const photo = new Image();
          photo.src = this.dataset.src;
          await photo.decode();
          if (!this.isConnected) return;
          if (!this.context || photo.naturalWidth !== 4800 || photo.naturalHeight !== 2940) throw new Error('Invalid rotation sheet');
          this.photo = photo;
          this.ready = true;
          this.querySelector('fieldset').disabled = false;
          this.status.textContent = this.dataset.ready;
          this.draw();
        } catch {
          if (this.isConnected) {
            this.status.textContent = this.dataset.error;
            this.retry.hidden = false;
          }
        } finally {
          this.loading = false;
          this.canvas.removeAttribute('aria-busy');
        }
      }
      draw() {
        if (!this.ready) return;
        const scale = Number(this.zoom.value);
        const width = 480 / scale;
        const height = 420 / scale;
        const x = (this.frame % 10) * 480 + (480 - width) / 2;
        const y = Math.floor(this.frame / 10) * 420 + (420 - height) / 2;
        this.context.drawImage(this.photo, x, y, width, height, 0, 0, 480, 420);
        this.rotation.value = this.frame;
      }
      stop() {
        clearInterval(this.timer);
        this.timer = null;
        this.play.textContent = this.dataset.play;
        this.play.setAttribute('aria-pressed', 'false');
      }
      disconnectedCallback() {
        this.stop();
        this.abort.abort();
        this.abort = null;
        this.drag = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
